import { Icon } from '@cbhq/cds-web/icons';
import { componentsThemeMap } from '../componentsThemeMap.js';
import { SectionComponentLayout } from '../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../providers/AnalyticsProvider.js';
import { useGlobalMicrocopy } from '../providers/MicrocopyProvider.js';
import '../ui/Div/index.js';
import { ErrorBoundary } from '../ui/ErrorBoundary.js';
import { SelectInput } from '../ui/Select/SelectInput.js';
import { Text } from '../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../ui/Div/Div.js';
function HeroTertiary({
  headline,
  icon,
  sortValue,
  setSortValue,
  articlesTotalCount,
  pre,
  anchor,
  style = 'default'
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    borderLine = _componentsThemeMap$s.borderLine;
  const microcopies = useGlobalMicrocopy();
  const hasArticleCountDisplay = !!articlesTotalCount && articlesTotalCount > 0;
  const hasSorting = sortValue && setSortValue;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HeroTertiary",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        as: "header",
        hasSpacingHorizontal: true,
        anchor: anchor,
        background: background,
        children: [/*#__PURE__*/jsxs(Div, {
          spacingVertical: {
            sm: 4,
            md: 5
          },
          columnGap: 3,
          flexDirection: {
            sm: 'column',
            lg: 'row'
          },
          alignItems: {
            sm: 'start',
            lg: 'center'
          },
          justifyContent: {
            sm: 'center',
            lg: 'start'
          },
          children: [/*#__PURE__*/jsxs(Text, {
            as: "h1",
            variant: hasArticleCountDisplay || hasSorting ? 'title2' : {
              sm: 'title2',
              md: 'display3',
              lg: 'display2'
            },
            color: foreground,
            flex: 1,
            spacingBottom: {
              sm: 2,
              md: 0
            },
            css: {
              whiteSpace: 'break-spaces'
            },
            alignItems: "center",
            children: [icon && /*#__PURE__*/jsx(Icon, {
              name: icon,
              size: "l",
              color: style !== 'primary' ? 'primary' : 'foreground',
              spacingEnd: 2
            }), /*#__PURE__*/jsxs(Div, {
              display: "inline-block",
              children: [pre && /*#__PURE__*/jsxs(Div, {
                as: "span",
                color: foregroundSecondary,
                css: {
                  whiteSpaces: 'pre'
                },
                display: "inline-block",
                children: [pre, ' ']
              }), headline]
            })]
          }), (hasArticleCountDisplay || hasSorting) && /*#__PURE__*/jsxs(Div, {
            gap: {
              sm: 2,
              md: 3
            },
            justifyContent: "space-between",
            alignItems: {
              sm: 'start',
              md: 'center'
            },
            flexDirection: {
              sm: 'column',
              md: 'row'
            },
            children: [hasArticleCountDisplay && /*#__PURE__*/jsxs(Text, {
              variant: "title4",
              color: foregroundSecondary,
              children: [articlesTotalCount, ' ', articlesTotalCount && articlesTotalCount > 1 ? microcopies.global.articles : microcopies.global.article]
            }), hasSorting && /*#__PURE__*/jsx(Div, {
              maxWidth: 500,
              children: /*#__PURE__*/jsx(SelectInput, {
                bordered: true
                // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
                ,

                onChange: opt => setSortValue(opt),
                initialValue: sortValue,
                label: microcopies.global.sortBy,
                optionValues: [{
                  value: 'asc',
                  label: microcopies.global.newest
                }, {
                  value: 'desc',
                  label: microcopies.global.oldest
                }]
              })
            })]
          })]
        }), /*#__PURE__*/jsx(Div, {
          spacingBottom: 7,
          children: /*#__PURE__*/jsx(Div, {
            as: "hr",
            background: borderLine,
            height: "1px",
            flex: 1
          })
        })]
      })
    })
  });
}
export { HeroTertiary };
//# sourceMappingURL=HeroTertiary.js.map
